var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimcardActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/simcard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simcard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2833 5.45033L13.725 2.89199C12.9417 2.10866 11.8833 1.66699 10.775 1.66699H6.66667C4.16667 1.66699 2.5 3.33366 2.5 5.83366V14.167C2.5 16.667 4.16667 18.3337 6.66667 18.3337H13.3333C15.8333 18.3337 17.5 16.667 17.5 14.167V8.39199C17.5 7.28366 17.0583 6.22533 16.2833 5.45033ZM8.35833 14.5587C8.6 14.8003 8.6 15.2003 8.35833 15.442C8.23333 15.567 8.075 15.6253 7.91667 15.6253C7.75833 15.6253 7.6 15.567 7.475 15.442L5.80833 13.7753C5.56667 13.5337 5.56667 13.1337 5.80833 12.892L7.475 11.2253C7.71667 10.9837 8.11667 10.9837 8.35833 11.2253C8.6 11.467 8.6 11.867 8.35833 12.1087L7.13333 13.3337L8.35833 14.5587ZM14.1917 13.7753L12.525 15.442C12.4 15.567 12.2417 15.6253 12.0833 15.6253C11.925 15.6253 11.7667 15.567 11.6417 15.442C11.4 15.2003 11.4 14.8003 11.6417 14.5587L12.8667 13.3337L11.6417 12.1087C11.4 11.867 11.4 11.467 11.6417 11.2253C11.8833 10.9837 12.2833 10.9837 12.525 11.2253L14.1917 12.892C14.4333 13.1337 14.4333 13.5337 14.1917 13.7753Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimcardActive);
export default __webpack_public_path__ + "static/media/simcard-active.b36750bf0726979e3cf48067defdd3e6.svg";
export { ForwardRef as ReactComponent };